import { createFileRoute } from '@tanstack/react-router'
import { AdminGuard } from '@/components/admin-guard'
import { HelpDeskHealthView } from '@/features/clients/HelpDeskHealthView'

function HelpDeskHealthRoute() {
  const { companyId } = Route.useParams()
  return (
    <AdminGuard>
      <HelpDeskHealthView companyId={companyId} />
    </AdminGuard>
  )
}

export const Route = createFileRoute('/clients/$companyId/helpdesk-health')({ component: HelpDeskHealthRoute })
